import * as Cesium from "cesium";
import PolylineTrailMaterialProperty from "./material/PolylineTrailMaterialProperty";
import { offsetRect } from "./effectConfig";

/** 在 bbox [west,south,east,north] 内生成随机点 */
function randomPointsInBbox(count, bbox) {
  const [west, south, east, north] = bbox;
  const features = [];
  for (let i = 0; i < count; i++) {
    features.push({
      geometry: {
        coordinates: [
          west + Math.random() * (east - west),
          south + Math.random() * (north - south),
        ],
      },
    });
  }
  return features;
}

export default class RectFlyLight {
  constructor(viewer, options = {}) {
    this.viewer = viewer;
    this.entities = [];
    this.bbox = options.bbox ?? offsetRect(-0.02, -0.02, 0.02, 0.02);
    // 原先 200 条且每条独立 Material，会注册 200 套 shader，极卡
    const count = options.count ?? 60;
    const ground = options.groundHeight ?? 1110;
    const sharedMaterial = new PolylineTrailMaterialProperty();

    randomPointsInBbox(count, this.bbox).forEach((item) => {
      const point = item.geometry.coordinates;
      const start = Cesium.Cartesian3.fromDegrees(
        point[0],
        point[1],
        ground
      );
      const end = Cesium.Cartesian3.fromDegrees(
        point[0],
        point[1],
        ground + 200 + Math.random() * 2500
      );
      const entity = viewer.entities.add({
        polyline: {
          positions: [start, end],
          width: 2,
          material: sharedMaterial,
        },
      });
      this.entities.push(entity);
    });
  }

  setVisible(show) {
    this.entities.forEach((e) => {
      e.show = show;
    });
  }
}
